export const trustpilotTemplateIds = {
  productMiniMultiSource: '577258fb31f02306e4e3aaf9',
  productReviewsMultiSource: '5763bccae0a06d08e809ecbb',
};

export const trustpilotBusinessUnitIds = {
  buid: process.env.NEXT_PUBLIC_TRUSTPILOT_BUID,
};
